"use client";

import { Navbar } from "~/components/Navbar/component";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";
import { TermsPage } from "~/modules/legal/pages/terms";

import type { JSX } from "react";

// // // //

export function TermsOfUseView(): JSX.Element {
    return (
        <PageTrack route={Routes.termsOfUse}>
            <UserFetcher>
                {({ user }) => <Navbar route={Routes.termsOfUse} user={user} />}
            </UserFetcher>
            <SidebarLayout pathname={Routes.termsOfUse}>
                <PageWrapper>
                    <TermsPage />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
